import { useEffect, useState } from 'react';
import RealTime from './RealTime';
import { GetHistorical } from '../../Api/getData.jsx';
import dayjs from 'dayjs';
import HistoryRangeDate from './HistoryRangeDate';
import HistoryByTrip from './HistoryByTrip';
import SPAL from './SPAL';
import { useDataFilter } from '../../components/global.jsx';
import { useSearchParams } from 'react-router-dom';
import FilterBucker from './components/FilterBuncker.jsx';
import WaterLevel from './components/Chart/WaterLevel.jsx';
import { HiChartBar, HiCog, HiClock, HiLightningBolt, HiCalendar, HiMap, HiCube, HiPlus, HiCheck, HiMinus } from 'react-icons/hi';

const StartRange = () => {
    // Ambil tanggal hari ini
    const startOfDay = dayjs().startOf('day'); // Mulai hari ini jam 00:00:00
    const formattedDateTime = startOfDay.format('YYYY-MM-DD HH:mm:ss.SSS');
    return formattedDateTime;
};

// EndRange: Waktu saat ini
const EndRange = () => {
    const currentDate = dayjs();
    const formattedDateTime = currentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDateTime;
};

const Analityc = () => {

    useEffect(() => {
        document.title = "NextSense - Analityc";
    }, []);

    useDataFilter();

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [ToleransiFill, setToleransiFill] = useState("120");
    const [ToleransiGuncangan, setToleransiGuncangan] = useState("120");
    const dataToleransi = [ToleransiFill, ToleransiGuncangan];

    const [data, setData] = useState([]);
    const [dataBunker, setDataBunker] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // const response = await getHistoryCal(start, end);
                const response = await GetHistorical(KodeCabang, ShipCode, StartRange(), EndRange(), ToleransiFill, ToleransiGuncangan)
                setData(response)
                // setData(response);
            } catch (error) {
                console.log(error);
            }
        }

        fetchData();
    }, [KodeCabang, ShipCode, ToleransiFill, ToleransiGuncangan]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4">
            <div className="space-y-6">
                {/* Header Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                        <div className="flex items-center space-x-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-xl flex items-center justify-center shadow-lg">
                                <HiChartBar className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold gradient-text">Analytics Dashboard</h1>
                                <p className="text-gray-600 mt-1">Advanced data analysis and insights</p>
                            </div>
                        </div>

                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-2 px-4 py-2 bg-success-50 rounded-xl border border-success-200">
                                <div className="w-3 h-3 bg-success-500 rounded-full animate-pulse"></div>
                                <span className="text-sm font-semibold text-success-700">Live Analytics</span>
                            </div>
                            <div className="flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-xl border border-blue-200">
                                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                                <span className="text-sm font-semibold text-blue-700">{data.length} Records</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tolerance Settings */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex items-center space-x-3 mb-6">
                        <div className="w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center">
                            <HiCog className="w-4 h-4 text-orange-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">Tolerance Settings</h2>
                            <p className="text-sm text-gray-600">Configure analysis parameters</p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                                Toleransi Fill (minutes)
                            </label>
                            <div className="relative">
                                <input
                                    type="number"
                                    className="input-modern w-full pl-4 pr-4 py-3 text-lg"
                                    onChange={(values) => setToleransiFill(values.target.value)}
                                    value={ToleransiFill}
                                    placeholder="Enter fill tolerance"
                                />
                                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                    <HiClock className="w-5 h-5 text-gray-400" />
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                                Toleransi Guncangan (minutes)
                            </label>
                            <div className="relative">
                                <input
                                    type="number"
                                    className="input-modern w-full pl-4 pr-4 py-3 text-lg"
                                    onChange={(values) => setToleransiGuncangan(values.target.value)}
                                    value={ToleransiGuncangan}
                                    placeholder="Enter vibration tolerance"
                                />
                                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                    <HiLightningBolt className="w-5 h-5 text-gray-400" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Analytics Charts */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center">
                                <HiLightningBolt className="w-4 h-4 text-green-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">Real Time Analysis</h3>
                                <p className="text-sm text-gray-600">Live data monitoring</p>
                            </div>
                        </div>
                        <RealTime onDataToleransi={dataToleransi} />
                    </div>

                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center">
                                <HiCalendar className="w-4 h-4 text-blue-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">Date Range Analysis</h3>
                                <p className="text-sm text-gray-600">Historical data trends</p>
                            </div>
                        </div>
                        <HistoryRangeDate dataSource={data} onDataToleransi={dataToleransi} />
                    </div>

                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center">
                                <HiMap className="w-4 h-4 text-purple-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">Trip Analysis</h3>
                                <p className="text-sm text-gray-600">Journey-based insights</p>
                            </div>
                        </div>
                        <HistoryByTrip onDataToleransi={dataToleransi} />
                    </div>

                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center">
                                <HiCube className="w-4 h-4 text-red-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">SPAL Analysis</h3>
                                <p className="text-sm text-gray-600">Special analysis module</p>
                            </div>
                        </div>
                        <SPAL onDataToleransi={dataToleransi} />
                    </div>
                </div>

                {/* Bunker History Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex items-center space-x-3 mb-6">
                        <div className="w-8 h-8 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                            <HiCube className="w-4 h-4 text-yellow-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">Bunker History</h2>
                            <p className="text-sm text-gray-600">Fuel management and consumption tracking</p>
                        </div>
                    </div>

                    <div className="mb-6 flex justify-center items-center">
                        <FilterBucker onData={(values) => setDataBunker(values)} />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
                            <div className="flex items-center space-x-3 mb-3">
                                <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                                    <HiChartBar className="w-4 h-4 text-white" />
                                </div>
                                <h3 className="text-sm font-semibold text-blue-700">Start Stock</h3>
                            </div>
                            <WaterLevel dataSource={dataBunker?.BeginingStock} title="Start Stock" />
                        </div>

                        <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4 border border-green-200">
                            <div className="flex items-center space-x-3 mb-3">
                                <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center">
                                    <HiCheck className="w-4 h-4 text-white" />
                                </div>
                                <h3 className="text-sm font-semibold text-green-700">Finish Stock</h3>
                            </div>
                            <WaterLevel dataSource={dataBunker?.EndingStock} title="Finish Stock" />
                        </div>

                        <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-4 border border-orange-200">
                            <div className="flex items-center space-x-3 mb-3">
                                <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                                    <HiPlus className="w-4 h-4 text-white" />
                                </div>
                                <h3 className="text-sm font-semibold text-orange-700">Filling</h3>
                            </div>
                            <WaterLevel dataSource={dataBunker?.BBM_IN} title="Filling" />
                        </div>

                        <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-4 border border-red-200">
                            <div className="flex items-center space-x-3 mb-3">
                                <div className="w-8 h-8 bg-red-500 rounded-lg flex items-center justify-center">
                                    <HiMinus className="w-4 h-4 text-white" />
                                </div>
                                <h3 className="text-sm font-semibold text-red-700">Consumption</h3>
                            </div>
                            <WaterLevel dataSource={dataBunker?.BBM_OUT} title="Consumption" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Analityc;